export default "__VITE_ASSET__b69e3d22__"